class Timeline {
    static init() {
        this.STEP = 3;
        this.blocs = document.querySelectorAll(".flextimeline");

        this.blocs.forEach(bloc => {
            bloc.currentItems = 0;
            bloc.items = bloc.querySelectorAll(".flextimeline__item");
            bloc.ctaMore = bloc.querySelector(".flextimeline__plus button");
            bloc.ctaMore.addEventListener("click", () => this.showMore(bloc));
            this.showMore(bloc);
        });
    }

    static showMore(bloc) {
        bloc.currentItems += this.STEP;
        for (let i = 0; i < bloc.items.length && i < bloc.currentItems; i++) {
            bloc.items[i].classList.add("flextimeline__item--visible");

            let blocParent = bloc.items[i].parents(".flextimeline__box");
            if(blocParent.length > 0){
                blocParent[0].classList.add("flextimeline__box--visible")
            }
        }

        if (bloc.currentItems >= bloc.items.length) {
            bloc.ctaMore.parentElement.classList.add("flextimeline__plus--hidden");
        }
    }
}

export default Timeline;


// WEBPACK FOOTER //
// ./src/scripts/components/timeline.js